const config = {    
    app: {
        API_URL: process.env.REACT_APP_API_URL || '',
        LOGIN_REDIRECT_URL: process.env.REACT_APP_LOGIN_REDIRECT_URL || 'not-found',
        LOGOUT_REDIRECT_URL: process.env.REACT_APP_LOGOUT_REDIRECT_URL || 'not-found',
        REACT_APP_API_VERSION: process.env.REACT_APP_API_VERSION || 'v1'
    }
};

export default config;